import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const EditLibraryIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  const fill = getThemeColor("icon-color");
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g transform="scale(0.68)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 1.5H15C15.825 1.5 16.5 2.175 16.5 3V12C16.5 12.825 15.825 13.5 15 13.5H6C5.175 13.5 4.5 12.825 4.5 12V3C4.5 2.175 5.175 1.5 6 1.5ZM1.5 4.5H3V15H13.5V16.5H3C2.175 16.5 1.5 15.825 1.5 15V4.5ZM12.75 3V6.75L12 6.1875L11.25 6.75V3H12.75ZM6 12H15V3H14.25V9.75L12 8.0625L9.75 9.75V3H6V12Z"
          fill={fill}
        />
      </g>
      <path
        d="M16.3842 8.31818C16.299 8.31818 16.2103 8.35227 16.1456 8.41704L15.5217 9.0409L16.8001 10.3193L17.424 9.69545C17.5569 9.56249 17.5569 9.34772 17.424 9.21477L16.6262 8.41704C16.5581 8.34886 16.4728 8.31818 16.3842 8.31818ZM15.1569 9.40568L11.3865 13.1761V14.4545H12.6649L16.4353 10.6841L15.1569 9.40568Z"
        fill={fill}
      />
    </svg>
  );
};

export default EditLibraryIcon;
